import { GET_ALL_RECORDS } from "../../constants";

export enum PaginationEnum {
    SHOW_ALL = GET_ALL_RECORDS,
    SHOW_10 = 10,
    SHOW_20 = 20,
    SHOW_50 = 50,
    SHOW_100 = 100,
}
